exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".events-chart-tooltip{background:rgba(0,0,0,.7);color:#fff;font-size:12px;padding:10px}.events-chart-tooltip .tooltip-header{text-align:center}.events-chart-tooltip table td{padding:2px}", ""]);

// exports
